import React from 'react';
import HelpScreenTable from '../pmt/views/HelpScreenTable';

export const ScreenMapping = [
  {
    id: 'help_screen',
    view: <HelpScreenTable />,
  },
];